module.exports = "<button id=modalClose type=button class=\"base-btn purple-btn v2-btn\" data-dismiss=modal>Cancel</button> <button type=button disabled=true class=\"btn btn-primary modalExportData {%- cssClassNameForExportButtonOnPopup %}\">Export</button>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/filtersutil/html/commonExportModalFooter.html
// module id = 1453
// module chunks = 1